module.exports = __webpack_public_path__ + "img/bg_xscb_cbe@2x.f337942b.png";